const resetPendoData = () => {
  if (window.pendo && window.pendo.visitorId) {
    window.pendo.clearSession();
  }
};

const clearPendoLocalStorage = () => {
  const pendoKeys = Object.keys(localStorage).filter(key => key.toLowerCase().indexOf('pendo') !== -1);
  pendoKeys.forEach(key => localStorage.removeItem(key));

  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const cookieName = cookie.split('=')[0].trim();
    if (cookieName.toLowerCase().includes('pendo')) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    }
  });
};

export const clearPendoSession = () => {
  if (typeof window.pendo !== 'undefined') {
    resetPendoData();
    clearPendoLocalStorage();
  }
};
